import PennText from "@/components/ui/text/PennText";
import {
  computeSelectedAppsTotals,
  formatTotalsUtilPercent,
  type SelectedAppsTotals,
} from "@/utils/comparison-selected-totals";
import type { PerAppCostBreakdown } from "@/api/calculate";

type SelectedAppsTotalsFooterProps = {
  perApp: PerAppCostBreakdown[];
  selectedApplicationIds: string[];
  showValues: boolean;
};

export function SelectedAppsTotalsFooter({
  perApp,
  selectedApplicationIds,
  showValues,
}: SelectedAppsTotalsFooterProps) {
  const totals = computeSelectedAppsTotals(perApp, selectedApplicationIds);
  if (!totals) return null;

  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50/60 p-3">
      <PennText
        as="p"
        className="compare-kpi-section-label mb-2"
        color="blue_grey"
      >
        Totals for selected applications
      </PennText>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-center">
        <TotalsUtilCell
          label="Total operator utilization"
          totals={totals}
          field="worker"
          showValues={showValues}
        />
        <TotalsUtilCell
          label="Total machine utilization"
          totals={totals}
          field="machine"
          showValues={showValues}
        />
      </div>
    </div>
  );
}

function TotalsUtilCell({
  label,
  totals,
  field,
  showValues,
}: {
  label: string;
  totals: SelectedAppsTotals;
  field: "machine" | "worker";
  showValues: boolean;
}) {
  const pct =
    field === "machine"
      ? totals.machineUtilizationPercent
      : totals.workerUtilizationPercent;
  const required =
    field === "machine" ? totals.requiredMachines : totals.requiredOperators;
  const requiredLabel =
    field === "machine" ? "Required machines" : "Required operators";

  return (
    <div className="flex flex-col items-center min-w-0">
      <PennText as="p" className="compare-kpi-section-label leading-tight break-words">
        {label}
      </PennText>
      <p className="compare-kpi-util-value mt-1 text-blue_grey1">
        {showValues ? formatTotalsUtilPercent(pct) : "—"}
      </p>
      <PennText as="p" size="xs" color="blue_grey" className="mt-0.5 leading-tight">
        {requiredLabel}: {showValues ? required : "—"}
      </PennText>
    </div>
  );
}
